import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, set } from 'lodash'

import ErrorMessage from '../../errormessage/ErrorMessage'
import InputDateField from '../../fields/inputdatefield/InputDateField'
import InputSelectField from '../../fields/inputselectfield/InputSelectField'
import './ExportExcelYara.scss'
import Modal from '../../app/customModal/Modal'

export default class ExportExcelYara extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      formFields: {
        from: props.from,
        to: props.to,
        shipType: 'all',
        administrativeFormat: 'default'
      },
      formErrors: [],
      formInvalidDateErrors: []
    }
  }

  static propTypes = {
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    onExportExcel: PropTypes.func.isRequired
  }

  render() {
    const isValidForm = this.isValidForm(this.state.formFields)

    return (
      <>
        <Modal.Content>
          {this.state.formErrors.length || this.state.formInvalidDateErrors.length ? (
            <ErrorMessage message={'Please make sure that you filled in all fields correctly'} />
          ) : null}

          <div className="detail-view-section">
            <h1>Export options</h1>
            <div className="detailview double-view">
              <InputDateField
                name={'From'}
                fieldName={'from'}
                fieldValue={this.state.formFields.from}
                required={true}
                error={
                  this.state.formErrors.indexOf('from') !== -1 ||
                  this.state.formInvalidDateErrors.indexOf('from') !== -1
                }
                onChange={this.onFormInputChange}
              />
              <InputDateField
                name={'To'}
                fieldName={'to'}
                fieldValue={this.state.formFields.to}
                required={true}
                error={
                  this.state.formErrors.indexOf('to') !== -1 || this.state.formInvalidDateErrors.indexOf('to') !== -1
                }
                onChange={this.onFormInputChange}
              />
            </div>
            <div className="detailview double-view">
              <InputSelectField
                title={'Ship type'}
                fieldName={'shipType'}
                fieldValue={this.state.formFields.shipType}
                onChange={this.onFormInputChange}
                options={['all', 'barge', 'seavessel']}
                setupValue={'all'}
                previousStatus={'all'}
              />
              <InputSelectField
                title={'Format'}
                fieldName={'administrativeFormat'}
                fieldValue={this.state.formFields.administrativeFormat}
                onChange={this.onFormInputChange}
                options={['default', 'administrative']}
                setupValue={'default'}
                previousStatus={'default'}
              />
            </div>
          </div>
        </Modal.Content>
        <Modal.Buttons>
          <div className={`save-btn btn ${isValidForm ? 'valid' : ''}`} onClick={this.checkAndSubmitForm}>
            <span>Download</span>
          </div>
        </Modal.Buttons>
      </>
    )
  }

  /**
   * When the value of a form input field changes
   */
  onFormInputChange = (value, field) => {
    const formFields = cloneDeep(this.state.formFields)
    set(formFields, field, value)
    this.setState({ formFields })
  }

  isValidForm = _fields => {
    // if there are form errors, set them in state and don't continue
    if (this.checkFields(_fields).length || this.checkDateFields(_fields).length) {
      return false
    } else {
      return true
    }
  }

  /**
   * Check if form fields are correct before updating visit in backend
   */
  checkAndSubmitForm = () => {
    const formErrors = this.checkFields(this.state.formFields)

    // if there are form errors, set them in state and don't continue
    if (formErrors.length) {
      this.setState({ formErrors })
      return
    }

    const formInvalidDateErrors = this.checkDateFields(this.state.formFields)

    if (formInvalidDateErrors.length) {
      this.setState({ formInvalidDateErrors })
      return
    }

    const administrativeFormat = this.state.formFields.administrativeFormat === 'administrative' ? true : false

    this.props.onExportExcel(
      this.state.formFields.from,
      this.state.formFields.to,
      this.state.formFields.shipType,
      administrativeFormat
    )
  }

  checkFields = _fields => {
    // very primitive form error checking
    const requiredFields = ['from', 'to']

    // Determine form errors (empty required fields)
    const formErrors = requiredFields.filter(requiredField => !_fields[requiredField] || _fields[requiredField] === '')

    return formErrors
  }

  checkDateFields = _fields => {
    const dateFields = ['from', 'to']

    const formInvalidDateErrors = dateFields.filter(dateField => {
      if (!_fields[dateField]) {
        return false
      }
      if (_fields[dateField] !== '') {
        return !/^\d+$/.test(_fields[dateField])
      }
      return false
    })

    return formInvalidDateErrors
  }
}
